import Vuex from 'vuex';
import AppModule from './app';
import BookingModule from './bookings';
import CustomerModule from './customer';
import MemberLeaveModule from './member-leaves';
import MemberExtraHoursModule from './member-extra-hours';
import ServiceLeaveModule from './service-leaves';
import ServiceExtraHoursModule from './service-extra-hours';
import ItemModule from './items';
import CartModule from './cart';
import ItemGroupModule from './item-groups';
import ItemCategoryModule from './item-categories';
import LogisticsModule from './logistics';
import OffersModule from './offers';
import NotificationsModule from './notifications';
import InterstitialsModule from './interstitials';
import SystemInterstitialsModule from './system-interstitials';
import PricingRuleModel from './pricing-rules';
import CampaignsModule from './campaigns';
import QuestionSectionsModule from './question-sections';
import GoogleReserveModule from './google-reserve';
import InvoiceModule from './invoices';
import BookingPassModule from './booking-passes';
import ServiceModule from './services';
import MemberModule from './members';
import CurrencyModule from './currencies';
import FormsModule from './forms';

export default new Vuex.Store({
	modules: {
		app: AppModule,
		bookings: BookingModule,
		customer: CustomerModule,
		'member-leaves': MemberLeaveModule,
		'member-extra-hours': MemberExtraHoursModule,
		'service-leaves': ServiceLeaveModule,
		'service-extra-hours': ServiceExtraHoursModule,
		'items': ItemModule,
		'cart': CartModule,
		'item-groups': ItemGroupModule,
		'item-categories': ItemCategoryModule,
		'logistics': LogisticsModule,
		'offers': OffersModule,
		'notifications': NotificationsModule,
		'interstitials': InterstitialsModule,
		'pricing-rules': PricingRuleModel,
		'campaigns': CampaignsModule,
		'system-interstitials': SystemInterstitialsModule,
		'question-sections': QuestionSectionsModule,
		'google-reserve': GoogleReserveModule,
		invoices: InvoiceModule,
		'booking-passes': BookingPassModule,
		'services': ServiceModule,
		'members': MemberModule,
		currencies: CurrencyModule,
		forms: FormsModule,
	}
})